export default {
  data () {
    return {
      categoryJa: {
        disorder: { label: '障害情報', color: 'error' },
        maintenance: { label: 'メンテナンス', color: 'warning' },
        notice: { label: 'お知らせ', color: 'success' }
      }
    }
  },
  methods: {
    translateCategoryJa (category) {
      if (typeof category === 'undefined') {
        return {}
      } else {
        return this.categoryJa[category]
      }
    }
  }
}
